var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import * as padLeft from 'pad-left';
import * as Raven from 'raven-js';
import { getScoreSystem } from '@crimp/lib-score-systems';
import ButtonAction from 'src/pages/components/utilities/ButtonAction';
var ScorePrintOutGenerator = (function (_super) {
    __extends(ScorePrintOutGenerator, _super);
    function ScorePrintOutGenerator(props) {
        var _this = _super.call(this, props) || this;
        _this.generateScorePrintOut = _this.generateScorePrintOut.bind(_this);
        _this.buildCsvDocument = _this.buildCsvDocument.bind(_this);
        _this.buildCsvHeader = _this.buildCsvHeader.bind(_this);
        _this.buildCsvClimber = _this.buildCsvClimber.bind(_this);
        return _this;
    }
    ScorePrintOutGenerator.prototype.generateScorePrintOut = function () {
        var dataBlob = new Blob(this.buildCsvDocument());
        var $download = window.document.createElement('a');
        $download.style.cssText = 'display: none;';
        $download.href = window.URL.createObjectURL(dataBlob);
        $download.download = "Results for " + this.props.round.name + ", " + this.props.category.name + ".csv";
        $download.click();
    };
    ScorePrintOutGenerator.prototype.buildCsvDocument = function () {
        var _this = this;
        var event = this.props.event;
        var category = this.props.category;
        var round = this.props.round;
        var routes = this.props.routes;
        var scoreJoins = category.isTeamCategory
            ? this.props.teamScoreJoins
            : this.props.athleteScoreJoins;
        var dataArray = [];
        var dataString = event.name + '\n';
        dataString += round.name + ", " + category.name + '\n\n';
        if (scoreJoins.length === 1) {
            dataString += 'No climbers were found in ' + category.name;
            dataArray.push(dataString);
            return dataArray;
        }
        var scoreSystem = getScoreSystem(round.scoreSystem, round, routes);
        var scoreHeaders = [];
        Object.keys(scoreSystem.schema).forEach(function (key) {
            if (key !== 'display') {
                scoreHeaders.push(key);
            }
        });
        dataString += this.buildCsvHeader(round, routes, scoreHeaders);
        dataArray.push(dataString);
        if (category.isTeamCategory) {
            scoreJoins.forEach(function (tSJ) {
                dataArray.push(_this.buildCsvTeam(round, scoreHeaders, tSJ));
            });
        }
        else {
            scoreJoins.forEach(function (aSJ) {
                dataArray.push(_this.buildCsvClimber(round, scoreHeaders, aSJ));
            });
        }
        return dataArray;
    };
    ScorePrintOutGenerator.prototype.buildCsvHeader = function (round, routes, scoreHeaders) {
        var dataString = 'Rank,Bib Number,Climber Name,Gender,Affiliation,,';
        scoreHeaders.forEach(function (h) {
            dataString += "\"Total\n" + h + "\",";
        });
        dataString += ',,';
        routes
            .sort(function (a, b) { return a.index - b.index; })
            .forEach(function (r) {
            scoreHeaders.forEach(function (h) {
                dataString += "\"" + round.code + (r.index + 1) + "\n" + h + "\",";
            });
            dataString += ',';
        });
        dataString += '\n';
        dataString = dataString.replace(/undefined/g, '');
        return dataString;
    };
    ScorePrintOutGenerator.prototype.buildCsvClimber = function (round, scoreHeaders, athleteScoreJoin) {
        var dataString = '"' + athleteScoreJoin.rank + '",'
            + '"' + round.code + padLeft(athleteScoreJoin.score.bibNumber, 3, '0') + '",'
            + '"' + athleteScoreJoin.athlete.name + '",'
            + '"' + athleteScoreJoin.athlete.gender + '",'
            + '"' + athleteScoreJoin.athlete.affiliation + '",,';
        var summated = typeof athleteScoreJoin.score.summated === 'string'
            ? JSON.parse(athleteScoreJoin.score.summated)
            : athleteScoreJoin.score.summated;
        scoreHeaders.forEach(function (h) {
            dataString += "\"" + summated[h] + "\",";
        });
        dataString += ',,';
        if (athleteScoreJoin.athleteScoreRoutes) {
            athleteScoreJoin.athleteScoreRoutes
                .sort(function (a, b) { return a.index - b.index; })
                .forEach(function (aSR) {
                var calculated = typeof aSR.calculated === 'string'
                    ? JSON.parse(aSR.calculated)
                    : aSR.calculated;
                scoreHeaders.forEach(function (h) {
                    dataString += '"' + calculated[h] + '",';
                });
                dataString += ',';
            });
        }
        dataString += '\n';
        dataString = dataString.replace(/undefined/g, '');
        return dataString;
    };
    ScorePrintOutGenerator.prototype.buildCsvTeam = function (round, scoreHeaders, teamScoreJoin) {
        var _this = this;
        var dataString = '"' + teamScoreJoin.rank + '",'
            + ','
            + '"' + teamScoreJoin.team.name + '",'
            + ','
            + ',,';
        var summated = typeof teamScoreJoin.score.summated === 'string'
            ? JSON.parse(teamScoreJoin.score.summated)
            : teamScoreJoin.score.summated;
        scoreHeaders.forEach(function (h) {
            dataString += "\"" + summated[h] + "\",";
        });
        dataString += '\n';
        teamScoreJoin.athletes.forEach(function (aSJ) {
            dataString += _this.buildCsvClimber(round, scoreHeaders, aSJ);
        });
        dataString += '\n';
        dataString = dataString.replace(/undefined/g, '');
        return dataString;
    };
    ScorePrintOutGenerator.prototype.render = function () {
        var event = this.props.event;
        var category = this.props.category;
        var round = this.props.round;
        if (!event || !category || !round) {
            return null;
        }
        return (React.createElement(ButtonAction, null,
            React.createElement("button", { onClick: this.generateScorePrintOut }, "Generate results print-out")));
    };
    return ScorePrintOutGenerator;
}(React.Component));
var mapStateToProps = function (state) {
    var scoreboard = state.scoreboard;
    var workspaceEvent = state.workspaceEvent;
    var categoryId = scoreboard.categoryId;
    var roundId = scoreboard.roundId;
    var event = workspaceEvent.event && workspaceEvent.event.data[0];
    var category = workspaceEvent.categories && workspaceEvent.categories.data.find(function (r) { return r.id === categoryId; });
    var round = workspaceEvent.rounds && workspaceEvent.rounds.data.find(function (r) { return r.id === roundId; });
    if (!event ||
        !categoryId ||
        !roundId ||
        !event ||
        !category ||
        !round ||
        !workspaceEvent.routes ||
        !workspaceEvent.teams ||
        !workspaceEvent.teamScores ||
        !workspaceEvent.athletes ||
        !workspaceEvent.athleteScores) {
        return;
    }
    var routes = workspaceEvent.routes.data
        .filter(function (r) { return r.roundId === roundId; });
    var scoreSystem = getScoreSystem(round.scoreSystem, round, routes);
    var teams = workspaceEvent.teams.data
        .filter(function (t) { return t.categoryId === categoryId; });
    var teamScores = workspaceEvent.teamScores.data
        .filter(function (ts) { return ts.roundId === roundId; });
    var athletes = workspaceEvent.athletes.data
        .filter(function (a) { return a.categoryId === categoryId; });
    var athleteScores = workspaceEvent.athleteScores.data
        .filter(function (s) { return s.roundId === roundId; });
    var athleteScoreRoutes = workspaceEvent.athleteScoreRoutes
        ? workspaceEvent.athleteScoreRoutes.data.filter(function (s) { return s.roundId === roundId; })
        : [];
    var athleteScoreJoins;
    var teamScoreJoins;
    if (category.isTeamCategory) {
        teamScoreJoins = teamScores.reduce(function (teamAccumulator, ts) {
            var team = teams.find(function (t) { return t.id === ts.teamId; });
            if (!team) {
                return teamAccumulator;
            }
            var teamAthletes = athletes.filter(function (a) { return a.teamId === ts.teamId; });
            var teamAthleteScores = athleteScores.filter(function (aS) { return aS.teamId === ts.teamId; });
            var teamScoreJoin = {
                team: team,
                score: ts,
                athletes: teamAthleteScores.reduce(function (athleteAccumulator, aS) {
                    var athlete = teamAthletes.find(function (a) { return a.id === aS.athleteId; });
                    if (!athlete) {
                        return athleteAccumulator;
                    }
                    athleteAccumulator.push({
                        athlete: athlete,
                        score: aS,
                        athleteScoreRoutes: athleteScoreRoutes
                            .filter(function (sr) { return sr.athleteId === athlete.id; })
                            .sort(function (a, b) { return a.index - b.index; }),
                    });
                    return athleteAccumulator;
                }, []),
            };
            teamScoreJoin.score.summated = scoreSystem.summateTeam(teamScoreJoin);
            teamAccumulator.push(teamScoreJoin);
            return teamAccumulator;
        }, []);
        try {
            scoreSystem.sort(teamScoreJoins);
        }
        catch (err) {
            Raven.captureException(err);
        }
    }
    else {
        athleteScoreJoins = athleteScores.reduce(function (accumulator, aS) {
            var athlete = athletes.find(function (a) { return a.id === aS.athleteId; });
            if (!athlete) {
                return accumulator;
            }
            accumulator.push({
                athlete: athlete,
                score: aS,
                athleteScoreRoutes: athleteScoreRoutes
                    .filter(function (sr) { return sr.athleteId === athlete.id; })
                    .sort(function (a, b) { return a.index - b.index; }),
            });
            return accumulator;
        }, []);
        try {
            scoreSystem.sort(athleteScoreJoins);
        }
        catch (err) {
            Raven.captureException(err);
        }
    }
    return {
        event: event,
        category: category,
        round: round,
        routes: routes,
        teamScoreJoins: teamScoreJoins,
        athleteScoreJoins: athleteScoreJoins,
    };
};
export default connect(mapStateToProps)(ScorePrintOutGenerator);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageDashboard/DashboardForm/DashboardFormRound/ScorePrintOutGenerator.tsx
// module id = 977
// module chunks = 0